import type { ReactNode } from 'react'
import { SearchMdIcon } from '@systemeio/icons'
import { useTranslation } from 'next-i18next'

interface Props {
  onOpen: () => void
  className?: string
}

const CommunitySearchFormTrigger = ({ onOpen, className }: Props): ReactNode => {
  const { t } = useTranslation()

  return (
    <button type="button" title={t('global.search')} className={className} onClick={onOpen}>
      <SearchMdIcon className="size-6 text-text-secondary" />
    </button>
  )
}

export { CommunitySearchFormTrigger }
